export const navItems = [
  { href: "#access", label: "访问入口" },
  { href: "#download", label: "APP下载" },
  { href: "#address", label: "最新地址" },
  { href: "#comics", label: "漫画资源" },
  { href: "#guide", label: "使用教程" },
  { href: "#faq", label: "常见问题" },
];

export const heroCards = [
  {
    icon: "ri-global-line",
    title: "官网入口",
    desc: "网页版直接打开，无需安装，电脑平板都能看。",
    href: "#access",
    tag: "最快捷",
  },
  {
    icon: "ri-smartphone-line",
    title: "APP 下载",
    desc: "安卓与苹果两种安装方式，随时离线追更。",
    href: "#download",
    tag: "超方便",
  },
  {
    icon: "ri-link-m",
    title: "最新地址",
    desc: "地址变化的原因与获取方式，一次说清楚。",
    href: "#address",
    tag: "防失联",
  },
  {
    icon: "ri-book-open-line",
    title: "在线看漫画",
    desc: "热门题材速览，找到你想看的类型。",
    href: "#comics",
    tag: "资源全",
  },
];

export const accessMethods = [
  {
    icon: "ri-computer-line",
    title: "网页版直接访问",
    badge: "免安装",
    desc: "在电脑或平板的浏览器地址栏输入网址即可打开，适合临时阅读、大屏幕看彩漫。",
    points: [
      "兼容 Chrome、Edge、Safari 等主流浏览器",
      "无需下载安装，打开即用",
      "阅读记录跟随账号同步",
    ],
  },
  {
    icon: "ri-smartphone-line",
    title: "手机 APP 客户端",
    badge: "推荐",
    desc: "安装安卓或 iOS 客户端后，可缓存章节、接收更新提醒，弱网环境下体验更稳定。",
    points: [
      "支持离线缓存与后台下载",
      "书架、追更提醒集中管理",
      "翻页与画质设置更细腻",
    ],
  },
  {
    icon: "ri-qr-code-line",
    title: "扫码与分享链接",
    badge: "便捷",
    desc: "通过已打开的页面生成入口二维码，或使用他人分享的页面链接，在手机上快速接续阅读。",
    points: [
      "手机与电脑之间无缝切换",
      "分享给朋友时自动带上章节",
      "无需重复搜索地址",
    ],
  },
  {
    icon: "ri-tv-2-line",
    title: "大屏与模拟器",
    badge: "进阶",
    desc: "想在电视或大显示器上观看时，可通过投屏或安卓模拟器运行客户端，获得沉浸式阅读体验。",
    points: [
      "投屏适合与家人共用大屏",
      "模拟器支持键鼠翻页",
      "适合长期追连载的用户",
    ],
  },
];

export const downloadGuides = [
  {
    platform: "Android 安卓",
    icon: "ri-android-line",
    steps: [
      "使用手机浏览器打开当前页面，进入「最新地址」分区确认可用入口。",
      "在页面中点击安卓下载按钮，浏览器会提示下载 APK 安装包。",
      "在系统设置中允许「安装未知来源应用」，再点击安装包完成安装。",
      "首次打开时按提示授予存储权限，用于缓存章节图片。",
    ],
    note: "请只从页面内提供的入口下载，避免从陌生第三方站点安装来路不明的安装包。",
  },
  {
    platform: "iOS 苹果",
    icon: "ri-apple-line",
    steps: [
      "推荐先用 Safari 打开网页版，登录账号后即可直接阅读。",
      "如客户端提供 TestFlight 或企业签名版本，按页面指引安装描述文件。",
      "安装完成后在「设置 - 通用 - VPN 与设备管理」中信任对应证书。",
      "回到桌面打开应用，使用同一账号登录即可同步书架。",
    ],
    note: "iOS 版本可能因签名到期暂时不可用，此时使用网页版同样可以正常阅读。",
  },
  {
    platform: "电脑 / 模拟器",
    icon: "ri-windows-line",
    steps: [
      "在电脑浏览器中直接打开网页版，分辨率越高阅读区域越大。",
      "如需客户端体验，可安装主流安卓模拟器。",
      "在模拟器内通过浏览器访问本页，下载并安装安卓客户端。",
      "模拟器建议开启 VT 加速，翻页与加载会更顺畅。",
    ],
    note: "模拟器会占用较多内存，老旧电脑建议优先使用网页版。",
  },
];

export const addressReasons = [
  {
    icon: "ri-refresh-line",
    title: "域名定期更换",
    desc: "为保障服务稳定，平台有时会启用新的访问域名，旧地址可能提示无法打开。",
  },
  {
    icon: "ri-shield-check-line",
    title: "线路与加速调整",
    desc: "遇到访问高峰时运营方会切换线路节点，部分入口在特定时段会临时不可用。",
  },
  {
    icon: "ri-information-line",
    title: "运营与合规调整",
    desc: "根据运营安排或合规要求，个别入口可能暂停或迁移，需要以最新公布为准。",
  },
  {
    icon: "ri-error-warning-line",
    title: "网络与缓存问题",
    desc: "有时候并非地址失效，而是本地 DNS 缓存或网络环境导致，换网络往往就能恢复。",
  },
];

export const addressChannels = [
  {
    icon: "ri-notification-3-line",
    title: "关注站内公告",
    desc: "进入任意可用入口后，留意首页公告栏，地址变动通常会第一时间在此说明。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "收藏并保存本页",
    desc: "将本导航页加入浏览器书签，地址发生变化时回到这里即可找到新的入口。",
  },
  {
    icon: "ri-smartphone-line",
    title: "优先使用客户端",
    desc: "安装客户端后由应用内部处理地址切换，基本不用自己手动寻找新网址。",
  },
  {
    icon: "ri-question-answer-line",
    title: "交流群与客服",
    desc: "官方交流渠道通常会同步最新地址，遇到长期打不开的情况可以前往询问。",
  },
];

export const verifyTips = [
  "确认页面顶部的站点名称与标识是否一致，正规入口不会频繁更换名称。",
  "查看域名拼写是否有细微差异，警惕把字母替换成数字的仿冒网址。",
  "不要在来路不明的页面上输入账号密码或支付信息。",
  "浏览时若被强制跳转到其他无关站点，应立即关闭并换用其他入口。",
];

export const comicCategories = [
  { id: "all", name: "全部" },
  { id: "hot", name: "热血" },
  { id: "romance", name: "恋爱" },
  { id: "mystery", name: "悬疑" },
  { id: "fantasy", name: "奇幻" },
  { id: "daily", name: "日常" },
  { id: "scifi", name: "科幻" },
];

export const comics = [
  {
    id: "c1",
    title: "烈焰少年",
    category: "hot",
    categoryName: "热血",
    author: "示例作品",
    status: "连载中",
    tags: ["少年", "格斗", "成长"],
    summary: "一名普通少年在火焰之力的指引下，踏上守护家乡的擂台之路。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20fiery%20young%20fighter%20hero%20with%20flaming%20fists%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20tangerine%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-01&orientation=portrait",
  },
  {
    id: "c2",
    title: "拳风再起",
    category: "hot",
    categoryName: "热血",
    author: "示例作品",
    status: "连载中",
    tags: ["竞技", "友情", "逆袭"],
    summary: "退役拳手重返赛场，用一双旧手套重新证明自己的价值。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20determined%20boxer%20raising%20a%20gloved%20fist%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20amber%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-02&orientation=portrait",
  },
  {
    id: "c3",
    title: "咖啡与四月的信",
    category: "romance",
    categoryName: "恋爱",
    author: "示例作品",
    status: "连载中",
    tags: ["治愈", "校园", "书信"],
    summary: "街角咖啡馆的店员，与每周寄来匿名信件的客人之间悄然萌生的心意。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20cozy%20coffee%20shop%20with%20a%20letter%20and%20a%20latte%20cup%2C%20soft%20romantic%20mood%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20coral%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-03&orientation=portrait",
  },
  {
    id: "c4",
    title: "天台上的风",
    category: "romance",
    categoryName: "恋爱",
    author: "示例作品",
    status: "已完结",
    tags: ["青春", "纯爱", "短篇"],
    summary: "两个总在教学楼天台相遇的高中生，把心事写在风里的一整个夏天。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20two%20silhouettes%20on%20a%20school%20rooftop%20under%20a%20big%20sky%2C%20soft%20youthful%20mood%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20peach%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-04&orientation=portrait",
  },
  {
    id: "c5",
    title: "沉钟镇谜案",
    category: "mystery",
    categoryName: "悬疑",
    author: "示例作品",
    status: "连载中",
    tags: ["推理", "小镇", "悬疑"],
    summary: "一座终年雾气笼罩的小镇，每隔十年就会响起一次无人敲响的钟声。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20misty%20old%20town%20with%20a%20mysterious%20clock%20tower%2C%20moody%20detective%20atmosphere%2C%20bold%20clean%20outlines%2C%20warm%20sepia%20and%20amber%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-05&orientation=portrait",
  },
  {
    id: "c6",
    title: "山海异兽录",
    category: "fantasy",
    categoryName: "奇幻",
    author: "示例作品",
    status: "连载中",
    tags: ["东方", "神话", "冒险"],
    summary: "少年背着一本会说话的旧图鉴，走遍山河寻访传说中的异兽。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20mythical%20eastern%20beast%20among%20mountains%20and%20clouds%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20jade%20green%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-06&orientation=portrait",
  },
  {
    id: "c7",
    title: "龙脊秘境",
    category: "fantasy",
    categoryName: "奇幻",
    author: "示例作品",
    status: "连载中",
    tags: ["探险", "魔法", "史诗"],
    summary: "沿着传说中巨龙的脊背，一支探险队向着从没人回得来的秘境进发。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20vast%20dragon%20spine%20mountain%20range%20with%20tiny%20explorers%2C%20epic%20fantasy%20mood%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20emerald%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-07&orientation=portrait",
  },
  {
    id: "c8",
    title: "周末料理屋",
    category: "daily",
    categoryName: "日常",
    author: "示例作品",
    status: "已完结",
    tags: ["美食", "治愈", "生活"],
    summary: "只在周末营业的小料理屋，用一道道家常菜收留城市里疲惫的人。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20tiny%20weekend%20restaurant%20with%20steaming%20home%20cooked%20dishes%2C%20cozy%20slice%20of%20life%20mood%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20orange%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-08&orientation=portrait",
  },
  {
    id: "c9",
    title: "星轨彼岸",
    category: "scifi",
    categoryName: "科幻",
    author: "示例作品",
    status: "连载中",
    tags: ["太空", "机甲", "命运"],
    summary: "在跨越星轨的漫长航行中，一名导航员发现了改变航向的秘密信号。",
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20comic%20book%20cover%20illustration%20of%20a%20lone%20navigator%20before%20a%20giant%20glowing%20star%20orbit%2C%20retro%20sci%20fi%20mood%2C%20bold%20clean%20outlines%2C%20warm%20cream%20and%20teal%20accent%20palette%2C%20simple%20minimal%20background%2C%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=dm-comic-09&orientation=portrait",
  },
];

export const guideSteps = [
  {
    no: "01",
    icon: "ri-compass-3-line",
    title: "选择适合的访问方式",
    desc: "只有临时阅读就选网页版，想长期追更就安装客户端，手机与电脑可随时切换。",
  },
  {
    no: "02",
    icon: "ri-link-m",
    title: "确认最新可用地址",
    desc: "先到「最新地址」分区了解地址变化的原因与获取途径，避免在失效入口上浪费时间。",
  },
  {
    no: "03",
    icon: "ri-user-follow-line",
    title: "注册并登录账号",
    desc: "使用手机号或第三方方式完成登录，书架、阅读进度和收藏会跟随账号同步。",
  },
  {
    no: "04",
    icon: "ri-book-read-line",
    title: "设置偏好并开始阅读",
    desc: "在设置里调整翻页方向、画质与阅读亮度，然后从感兴趣的分类里挑一本开始。",
  },
];

export const guideTips = [
  "建议固定使用同一个账号登录，避免阅读记录分散在不同设备上无法同步。",
  "缓存章节会自动占用手机存储，可在设置中清理已看完的缓存释放空间。",
  "把本页加入书签，地址变动时不用重新搜索就能找到新的入口。",
];

export const faqList = [
  {
    q: "抖漫官网入口在哪里？怎样才能找到官网？",
    a: "官网入口并不是一个固定不变的网址。比较稳妥的做法是：优先安装客户端，由应用内部处理访问；或在网页版中留意首页公告。本页的「访问入口」与「最新地址」两个分区已经汇总了多种访问途径和判断方法，按顺序查看即可。",
  },
  {
    q: "为什么抖漫的地址会经常变化？",
    a: "地址变化通常与域名调整、线路切换、运营合规安排有关，也可能只是本地网络或 DNS 缓存导致的临时无法访问。可以先更换网络或清理浏览器缓存再试，如果仍然打不开，再前往本页「最新地址」分区查看获取新地址的渠道。",
  },
  {
    q: "网页版和 APP 客户端有什么区别？该选哪个？",
    a: "网页版免安装、打开即用，适合在电脑上临时阅读；APP 客户端支持离线缓存、追更提醒和更细腻的翻页设置，适合长期追连载。两者账号互通，可以根据场景灵活搭配使用。",
  },
  {
    q: "下载 APP 时需要注意什么？",
    a: "请只通过页面内提供的入口下载，不要在陌生的第三方站点安装来路不明的安装包。安卓安装时系统会提示「未知来源」，确认来源后再继续；iOS 若提示证书失效，改用网页版同样可以正常阅读。",
  },
  {
    q: "打开页面后一直加载不出来怎么办？",
    a: "可以先按顺序排查：切换 Wi-Fi 与移动网络、清理浏览器缓存、更换浏览器、关闭可能干扰加载的插件或代理。如果多种方式都无效，说明该入口可能暂时失效，换用其他入口即可。",
  },
  {
    q: "忘记账号或密码了怎么找回？",
    a: "登录页面通常提供「忘记密码」入口，可通过绑定的手机号或邮箱重置。若无法找回，可以联系站内客服说明情况，建议平时记住绑定的手机号，方便日后快速验证身份。",
  },
  {
    q: "阅读时提示 VIP 或章节锁定是怎么回事？",
    a: "部分作品的部分章节属于付费内容，需要开通相应权益后才能阅读，未解锁的章节一般会显示提示。具体权益与规则以平台页面说明为准，建议先阅读免费章节再决定是否开通。",
  },
  {
    q: "如何判断自己访问的是否是正规页面？",
    a: "可以核对页面顶部的站点名称与标识是否一致、域名拼写是否异常，并避免在任何来路不明的页面输入账号与支付信息。本页「最新地址」分区也整理了几条识别要点，可对照检查。",
  },
];

export const safetyTips = [
  {
    icon: "ri-shield-keyhole-line",
    title: "保护账号安全",
    desc: "不要向任何人透露登录密码与验证码，公共设备阅读后记得退出登录。",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "警惕仿冒页面",
    desc: "遇到要求重复登录、索取支付信息或强制跳转的页面，应立即关闭。",
  },
  {
    icon: "ri-eye-line",
    title: "适度用眼休息",
    desc: "长时间阅读建议开启护眼或夜间模式，每隔一段时间让眼睛休息一下。",
  },
  {
    icon: "ri-download-2-line",
    title: "安装来源可靠",
    desc: "只在页面提供的入口下载客户端，安装前留意应用申请的权限是否合理。",
  },
];

export const stats = [
  { value: "4 类", label: "访问途径", icon: "ri-route-line" },
  { value: "7 类", label: "漫画题材", icon: "ri-book-2-line" },
  { value: "3 种", label: "安装方式", icon: "ri-install-line" },
  { value: "8 条", label: "常见问答", icon: "ri-questionnaire-line" },
];

export const footerLinks = [
  { href: "#access", label: "访问入口" },
  { href: "#download", label: "APP下载" },
  { href: "#address", label: "最新地址" },
  { href: "#comics", label: "漫画资源" },
  { href: "#guide", label: "使用教程" },
  { href: "#faq", label: "常见问题" },
];

export const footerNotice = [
  "本页面为访问方式与使用说明的整理导航，不提供账号注册、充值或任何交易服务。",
  "页面中的漫画名称、作者与剧情均为题材示例，用于说明内容分类，不代表实际收录作品。",
  "请遵守当地法律法规，合理安排阅读时间，并注意保护个人信息与账号安全。",
];